<template>
    <div>
        <!-- Show if we think this job has already been paid -->
        <div class="row" v-if="jobAlreadyPaid">
            <div class="col-6 offset-3">
                <div class="card">
                    <div class="card-body text-center">
                        <h3 class="text-center mb-3">
                            <span class="fa fa-phone text-success mr-1"></span>
                            Please Call Us                       
                        </h3>
                        <p style="font-size: 1.3em;">
                            We can't process online payment for your survey at {{ jobDetails.address }} at the moment.
                        </p>
                        <p style="font-size: 1.3em;">Please call our friendly team on 01904 468881 for further assistance.</p>
                    </div>
                </div>
            </div>
        </div>
        <!-- Show when job details loaded and this is not a previously paid job -->
        <div class="row" v-if="!jobAlreadyPaid">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-8 offset-lg-2">
                <div class="card" v-if="jobDetails">
                    <div class="card-body">
                        <h3 class="card-title" style="color: #4c6ab0;">Hello, {{ jobDetails.client }}</h3>
                        <h5 class="card-title">Thank you for choosing to pay for your survey online</h5>
                        <hr>

                        <table class="survey-info">
                            <tbody>
                                <tr>
                                    <td class="icon-cell"><span class="fa fa-home mr-1"></span></td>
                                    <td> Subject Property:</td>
                                    <td>{{ jobDetails.address }}</td>
                                </tr>
                                <tr>
                                    <td class="icon-cell"><span class="fa fa-info-circle mr-2"></span></td>
                                    <td>Our reference:</td>
                                    <td>{{ jobDetails.job_ref }}</td>
                                </tr>
                                <tr>
                                    <td class="icon-cell"><span class="fa fa-calendar mr-2"></span></td>
                                    <td>Date:</td>
                                    <td>{{ moment(jobDetails.date).format('DD/MM/YYYY') }}</td>
                                </tr>
                                <tr>
                                    <td class="icon-cell"><span class="fa fa-gbp mr-2"></span></td>
                                    <td>Our fee:</td>
                                    <td>£{{ grossPriceFormatted }} (includes £{{ vatFormatted }} VAT)</td>
                                </tr>
                            </tbody>
                        </table>

                        <div class="card mb-3 mt-4 ebook-cta">
                            <div class="row no-gutters">
                                <div class="col d-none d-sm-block" style="max-width: 160px;">
                                    <img src="@/assets/jcr-book-cover.jpg" class="card-img" alt="How to be a Smarter House Buyer eBook">
                                </div>
                                <div class="col">
                                    <div class="card-body">
                                        <h4 class="card-title">Customers also bought..</h4><!-- 
                                        <h5 class="card-title">"How to be a Smarter House Buyer" eBook</h5> -->
                                        <p class="card-text"><em>Become a smarter house buyer by learning trade secrets. Discover why the housing market is faulty and how you can navigate round it.</em></p>
                                        <div class="form-group form-check">
                                            <input type="checkbox" class="form-check-input" id="cbAddEBook" v-model="addEBook">
                                            <label class="form-check-label" for="addEBook">
                                                Yes please, add <strong>"How to be a Smarter House Buyer"</strong> eBook for just £4.99
                                            </label>
                                        </div>

                                        <div class="d-block d-sm-none pl-2 pt-2 pr-2 pb-2 text-center">
                                            <img src="@/assets/jcr-book-cover.jpg" class="card-img" alt="How to be a Smarter House Buyer eBook" style="max-width: 200px;">
                                        </div>                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="card-footer cart-total">
                        Cart Total: <span class="text-success"><strong>£{{ calculatedTotal }}</strong></span>
                    </div>
                </div>

                <div class="card mt-3">
                    <div class="card-body">
                        <p style="font-size: 1.2em;">
                            Please <router-link :to="{ name: termsPath }" target="_blank">click here to read the terms and conditions relating to your {{ jobDetails.job_type }}</router-link>
                        </p>
                        <div class="form-group form-check" style="font-size: 1.2em;">
                            <input type="checkbox" class="form-check-input" id="cbAgreeTerms" v-model="agreesToTerms">
                            <label class="form-check-label" for="cbAgreeTerms">
                                I have read and agreed to the terms and conditions relating to my Building Survey.
                            </label>
                        </div>

                        <button class="btn btn-block btn-success" style="font-size: 1.4em;" 
                                :disabled="!agreesToTerms || isCheckingOut" 
                                @click="checkout">
                            <span class="fa fa-shopping-cart mr-2" v-if="!isCheckingOut"></span>
                            <span class="fa fa-spinner fa-spin mr-2" v-if="isCheckingOut"></span>
                            Continue to Checkout
                        </button>
                    </div>
                </div>
            </div>
        </div>        
    </div>
</template>

<script>
    import { getCheckoutSessionFromStorage } from '../../utils/utils'
    import axios from 'axios'

    export default {
        props: {
            jobDetails: Object,
            jobToken: String
        },
        data() {
            return {
                addEBook: false,
                agreesToTerms: false,
                isCheckingOut: false,
                jobAlreadyPaid: false,
                checkoutError: null
            }
        },
        mounted() {
            console.log(this.jobDetails.stripe_account)
            let sessionRecord = getCheckoutSessionFromStorage(`CHECKOUT_SESSION_${this.jobDetails.job_ref}`)            
            if (sessionRecord && sessionRecord.is_complete) {
                this.jobAlreadyPaid = true
            }
        },
        computed: {
            grossPriceFormatted: function() {
                let net = parseFloat(this.jobDetails.price)
                let vat = parseFloat(this.jobDetails.vat)
                return (net + vat).toFixed(2)
            },
            vatFormatted: function() {
                return parseFloat(this.jobDetails.vat).toFixed(2)
            },
            calculatedTotal: function() {
                let eBookPrice = this.addEBook ? 4.99 : 0
                let jobPrice = parseFloat(this.jobDetails.price) + parseFloat(this.jobDetails.vat)
                return (jobPrice + eBookPrice).toFixed(2)
            },
            termsPath: function() {
                let companyCode = this.jobDetails.job_ref.startsWith('CR') ? 'cr' : 'sd'
                let surveyTypeCode = this.jobDetails.job_type.toLowerCase().indexOf('homemover') > -1 ? 'hmv' : 'bs'
                let path = `payment-terms-${companyCode}-${surveyTypeCode}`
                return path
            }
        },
        methods: {
            async checkout() {
                try {
                    this.isCheckingOut = true
                    let sessionUrl = `/.netlify/functions/create-stripe-session`
                    let requestBody = {
                        add_ebook: this.addEBook,
                        job_token: this.jobToken
                    }

                    // Create Stripe checkout session and redirect                    
                    let sessionResult = await axios.post(sessionUrl, requestBody)                    
                    console.log('Success!', sessionResult)

                    if (sessionResult.data && sessionResult.data.stripe_session_id) {
                        let stripeSessionId = sessionResult.data.stripe_session_id
                        
                        // Persist the job reference along with checkout session ID
                        let sessionRecord = {
                            job_ref: this.jobDetails.job_ref,
                            session_id: stripeSessionId,
                            is_complete: false
                        }
             
                        localStorage.setItem(stripeSessionId, JSON.stringify(sessionRecord))
                        localStorage.setItem(`CHECKOUT_SESSION_${this.jobDetails.job_ref}`, JSON.stringify(sessionRecord))

                        // Go for Stripe redirect
                        Stripe(this.jobDetails.stripe_account).redirectToCheckout({
                            sessionId: sessionResult.data.stripe_session_id
                        }).then((result) => {
                            console.log('The result is:', result)
                        })
                    }
                    else {
                        console.error('Stripe session error. Response from server was', sessionResult)
                    }
                } catch (error) {
                    console.error('Error creating checkout session', error)
                    this.checkoutError = error
                }

            }
        }
    }
</script>

<style lang="scss" scoped>
    table.survey-info {
        width: 100%;
        font-size: 1.2em;
        border-collapse: separate;
        border-spacing: 5px;

        .icon-cell {
            text-align: center;
            width: 30px;
            color: #4c6ab0;
        }
    }

    .ebook-cta {
        background: #f0fceb;
        color: #267828;

        p, label {
            font-size: 1.3em;            
        }
    }

    .cart-total {
        font-size: 1.4em;
    }
</style>